// src/components/copilot/blocks/TextBlock.js
export default function TextBlock({ block }) {
  return <p className="text-sm text-foreground whitespace-pre-wrap">{block.text}</p>;
}
